import { useMemo } from 'react'
import { createColumnHelper, Flex, Label, Loading, Table, Text } from 'ui'
import { AllCompaniesMembersResponse } from 'api/company'
import { useEditMemberContext } from '../context/EditMemberProvider'
import { RemoveCompanyButton } from './RemoveCompanyButton'
import { useAuthContext } from 'components/auth'

const companiesColumnHelper =
  createColumnHelper<
    AllCompaniesMembersResponse['members'][number]['companies'][number]
  >()

const CompanyNameCell = ({
  company,
}: {
  company: AllCompaniesMembersResponse['members'][number]['companies'][number]
}) => {
  const { company: currentCompany } = useAuthContext()

  return (
    <Flex flexDirection="row" alignItems="center" gap={2}>
      <Text>{company.name}</Text>
      {company.id === currentCompany?.id && (
        <Label variant="success" size="small">
          Current
        </Label>
      )}
    </Flex>
  )
}

const CompanyNameHeader = () => {
  const {
    state: { isLoadingMember },
  } = useEditMemberContext()
  return (
    <Flex flexDirection="row" alignItems="center" gap={2}>
      <Text>Company</Text>
      {!!isLoadingMember && <Loading type="button" />}
    </Flex>
  )
}

export const CompaniesTable = () => {
  const {
    state: { member },
  } = useEditMemberContext()

  const companies = useMemo(() => {
    if (!member) {
      return []
    }
    return member.companies
  }, [member])

  const companiesColumns = [
    companiesColumnHelper.accessor('name', {
      header: CompanyNameHeader,
      cell: (info) => <CompanyNameCell company={info.row.original} />,
    }),
    companiesColumnHelper.accessor('id', {
      header: '',
      size: 30,
      cell: (info) => <RemoveCompanyButton company={info.row.original} />,
    }),
  ]

  return <Table columns={companiesColumns} data={companies} />
}
